import React from 'react'
import Hero from '../hero/Hero'
import Logos from '../logos/Logos'
import BusinessSupport from '../businesssupport/BusinessSupport'
import Services from '../services/Services'
import Testimonials from '../testimonials/Testimonials'
import Contact from '../contact/Contact'
import ReelsComponent from '../reels/ReelsComponent'
import Product from '../productShowCase/Product'
import BrandLogo from '../brandlogos/BrandLogo'
import VideoWithText from '../videoText/VideoWithText'
import WorldMapComponent from '../worldmap/WorldMap'

const Home = () => {
  return (
    <div>
      <Hero/>
      <Logos/>
      <Product/>
      <VideoWithText/>
      <BusinessSupport/>
      <Services/>
      <Testimonials/>
      <BrandLogo/>
      <WorldMapComponent/>
      <ReelsComponent/>
      <Contact/>
    </div>
  )
}

export default Home
